import { useEffect, Dispatch, useCallback } from 'react';

import { EPostFormActionType, TPostFormActions } from './postFormActions';
import { EPostFormFieldName, IBlogPostFormFields, IPostForm } from '../../types/postForm';
import { ERequestStatus } from '../../types/requestStatus';

/** Пропсы и обработчики для филда Обложка поста */
export const useFeaturedImageField = (state: IPostForm<IBlogPostFormFields>, dispatch: Dispatch<TPostFormActions>) => {
  const {
    formStatus,
    fields: { [EPostFormFieldName.FeaturedImage]: fieldState },
  } = state;

  /** Сбрасывает филд после успешной отправки формы */
  useEffect(() => {
    if (formStatus !== ERequestStatus.Succeed) {
      return;
    }

    //dispatch({ type: EPostFormActionType.SetFieldValue, payload: { fieldName: EPostFormFieldName.Title, value: '' } });
  }, [dispatch, formStatus]);

  const handleChangeValue = useCallback(
    (value: string) => {
      dispatch({
        type: EPostFormActionType.SetField,
        payload: { fieldName: EPostFormFieldName.FeaturedImage, value: { ...fieldState, value } },
      });
    },
    [dispatch, fieldState],
  );

  return {
    ...fieldState,
    onChange: handleChangeValue,
  };
};
